<template>
  <div>
    <el-card v-for="(item, index) in form" :key="index">
      <div>
        <el-form
          size="mini"
          style="margin-left: -0.8125rem"
          ref="formRefs1"
          :rules="rules"
          :model="item"
          label-width="8.25rem"
          :disabled="isDisabled"
        >
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="等级">
                <el-input
                  v-model="item.cardLevelText"
                  style="width: 80%"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>           
                 <el-button
                  icon="iconfont icon-a-shanchu11"
                  @click="delBtnDialog(item, index)"
                  >删除</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="等级中文名称">
                <el-input v-model="item.levelName_cn" style="width: 80%">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="等级英文名称">
                <el-input v-model="item.levelName_en" style="width: 80%">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="3">
              <el-form-item label="是否基础级别">
                <el-checkbox v-model="item.isDefaultLvl"></el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="是否VIC">
                <el-checkbox v-model="item.isVIC"></el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="18"></el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="升级条件">
                <el-radio-group
                  v-model="item.upCondition"
                  @change="changeUpCondition(item)"
                >
                  <el-row style="margin-top: 10px">
                   <el-radio :label="0">绑定电话</el-radio>
                  </el-row>
                  <el-row style="margin-top: 10px">
                    <el-radio :label="1">金额</el-radio>
                    <span
                      style="
                        width: 4.75rem;
                        display: inline-block;
                        font-size: 0.875rem;
                        margin-left: 1.25rem;
                      "
                      >注册日期</span
                    >
                    <el-input
                      prop="timeLength"
                      v-model="item.timeLength"
                      class="min"
                      style="width: 3.125rem"
                      type="text"
                      onkeyup="value=value.replace(/[^\d]/g,'')"
                      :disabled="item.upCondition==1?false:true"
                    ></el-input>
                    <span
                      style="
                        width: 10.375rem;
                        display: inline-block;
                        font-size: 0.875rem;
                        margin-left: 0.1875rem;
                      "
                      >个月后，且累计金额</span
                    >
                    <el-input
                      v-model="item.sumAmt"
                      class="min"
                      style="width: 6.25rem"
                      type="text"
                      :disabled="item.upCondition==1?false:true"
                      onkeyup="value=value.replace(/[^\d]/g,'')"
                      size="small"
                    ></el-input>
                  </el-row>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="24">
                  <div style="margin-top: 25px"></div>
                  <el-form-item label="或">
                    <el-radio-group v-model="item.onlyMode">
                      <el-row style="margin-top: 4px">
                        <el-radio :label="1"  :disabled="item.upCondition==1?false:true">当日累积金额</el-radio>
                        <el-input
                          v-model="item.oneMaxAmt1"
                          class="min"
                          style="width: 8.25rem; margin-left: 0.25rem"
                          oninput="value=value.replace(/[^0-9.]/g,'')"
                          :disabled="item.upCondition==1&&item.onlyMode==1?false:true"
                        ></el-input>
                      </el-row>
                      <el-row style="margin-top: 10px">
                        <el-radio :label="2" :disabled="item.upCondition==1?false:true">当次消费额</el-radio>
                        <el-input
                          v-model="item.oneMaxAmt2"
                          class="min"
                          style="width: 8.25rem; margin-left: 1.25rem"
                          oninput="value=value.replace(/[^0-9.]/g,'')"
                          :disabled="item.upCondition==1&&item.onlyMode==2?false:true"
                        ></el-input>
                      </el-row>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="推荐客户经理级别">
                <el-select style="width: 80%" v-model="item.accountLvlID">
                          <el-option v-for="item in lists" :key="item.accLevel" :value="item.accountLvlID" :label="item.accountName"></el-option>
                  </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="仅限客户经理拨打电话">
                <el-checkbox-group readonly v-model="item.isForbitPhone">
                    <el-checkbox :checked="item.isForbitPhone" v-model="item.isForbitPhone" name="type"></el-checkbox>
                  </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="等级有效期">
                <el-radio-group v-model="item.lvlAvailMode"
                 @change="changeLvlAvailMode(item)">
                  <el-row style="margin-top: 8px">
                    <el-radio :label="1">永久有效</el-radio>
                  </el-row>
                  <el-row style="margin-top: 8px">
                    <el-radio :label="2">有效期</el-radio>
                    <el-input
                      v-model="item.lvlAvailMonth"
                      class="min"
                      style="width: 4.125rem; margin-left: 0.125rem"
                      type="text"
                      oninput="value = value.replace(/[^\d{2}\/{1}\d{2}$]/ig,'')"
                      :readonly="readonly"
                      :disabled="item.lvlAvailMode==2?false:true"
                    ></el-input>
                    <span
                      style="
                        width: 1.25rem;
                        display: inline-block;
                        font-size: 0.875rem;
                        margin-left: 0.3125rem;
                      "
                      >月</span
                    >
                  </el-row>
                  <el-row style="margin-top: 8px">
                    <el-radio :label="3">特定</el-radio>
                    <el-input
                      v-model="item.implClassName"
                      class="min"
                      style="width: 4.125rem; margin-left: 1.025rem"
                      type="text"
                      :disabled="item.lvlAvailMode==3?false:true"
                    ></el-input>
                  </el-row>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row :gutter="3">
            <el-form-item label="保级条件">
              <el-radio-group v-model="item.holdLvlTransTimes">
                <el-col>
                  <el-radio :label="0" style="margin-top: 8px"
                    >累计金额</el-radio
                  >
                  <el-input
                    v-model="item.holdLvlSumAmt1"
                    class="min"
                    style="width: 8.125rem; margin-left: 2.125rem"
                    oninput="value=value.replace(/[^0-9.]/g,'')"
                  ></el-input>
                  <span
                    style="
                      width: 1.25rem;
                      display: inline-block;
                      font-size: 0.875rem;
                      margin-left: 0.3125rem;
                    "
                    >元</span
                  >
                </el-col>
                <el-col style="margin-top: 8px">
                  <el-radio :label="1">消费</el-radio>
                  <el-input
                    v-model="item.holdLvlSumAmt2"
                    class="min"
                    style="width: 8.125rem; margin-left: 4.125rem"
                  ></el-input>
                  <span
                    style="
                      width: 1.25rem;
                      display: inline-block;
                      font-size: 0.875rem;
                      margin-left: 0.3125rem;
                    "
                    >笔</span
                  >
                </el-col>
              </el-radio-group>
            </el-form-item>
          </el-row> -->
          <el-row :gutter="3">
            <el-form-item label="保级条件">    
              <el-form-item label="累计消费金额" prop="holdLvlSumAmt">    
                <el-col>        
                  <el-input
                    v-model="item.holdLvlSumAmt"
                    class="min"
                    style="width: 8.125rem;margin-left:5px"
                    oninput="value=value.replace(/[^0-9.]/g,'')"
                  ></el-input>
                  <span
                    style="
                      width: 1.25rem;
                      display: inline-block;
                      font-size: 0.875rem;
                      margin-left: 0.3125rem;
                    "
                    >元</span
                  >
                </el-col>
              </el-form-item>
                <el-form-item label="消费" prop="holdLvlTransTimes">
                <el-col>
                  <el-input
                    v-model="item.holdLvlTransTimes"
                    class="min"
                    style="width: 8.125rem;margin-left:5px"
                  ></el-input>
                  <span
                    style="
                      width: 1.25rem;
                      display: inline-block;
                      font-size: 0.875rem;
                      margin-left: 0.3125rem;
                    "
                    >笔</span
                  >
                </el-col>
                </el-form-item>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <!-- 删除弹窗 -->
      <div class="delete">
        <el-dialog
          width="20%"
          title="是否删除消费等级"
          :visible.sync="deleteFormVisible"
          :closeOnClickModal="false"
        >
          <div style="height: 50px; font-size: 14px; font-weight: 700">
            <p>
              <i
                class="iconfont icon-jingshi"
                style="font-size: 28px; color: #f39b21"
              ></i>
              是否真的要<span style="color: #ff0000">删除</span>消费等级?
            </p>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="deleteSave">确 定</el-button>
            <el-button @click="deleteFormVisible = false">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </el-card>
  </div>
</template>
<script>
import { getcpyNo } from "@/utils/auth";
import { ruleInsert, ruleDeleteApi,accountmnglvlSelectList } from "@/api/user";
export default {
  name: `consumption`,
  props: {
    radioValue: undefined,
    form: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isDisabled: Boolean,
  },
  data() {
    return {
      deleteFormVisible:false,
      rules: {
        oneMaxAmt: [
          { required: true, message: "月份不能为空", trigger: "blur" },
        ],
        holdLvlSumAmt: [
          { required: true, message: "累计金额不能为空", trigger: "blur" },
        ],
        holdLvlTransTimes: [
          { required: true, message: "消费金额不能为空", trigger: "blur" },
        ],
      },
      levelIDNum: null,
      readonly: false,
      delItem:"",
      delIndex:"",
      lists:[]
    };
  },
  created() {
    // console.log("子组件", this.form);
    this.getaccountmnglvlSelectList();
    
  },
  methods: {
    addLent() {
      this.form.push({
        cardLevel: this.form.length + 1,
        cardLevelText: this.form.length + 1,
        cpyNO: "",
        addressType: 2,
        // createTime: "",
        // createUserID: "",
        holdLvlSumAmt: "",
        holdLvlTransTimes: "",
        implClassName: "",
        isDefaultLvl: false,
        isVIC: "",
        levelID: "",
        levelName_cn: "",
        levelName_en: "",
        lvlAvailMode: "",
        lvlAvailMonth: "",
        oneMaxAmt: "",
        onlyMode: "",
        state: "",
        sumAmt: "",
        timeKind: "",
        timeLength: "",
        upCondition: "",
        // updateTime: "",
        // updateUserID: "",
        accountLvlID:"",
        isForbitPhone:""

      });
    },
    delBtnDialog(item,index){
      this.deleteFormVisible=true
      this.delItem=item;
      this.delIndex=index;
    } ,
    deleteSave() {
      // console.log(item, index);
      if (this.delItem.addressType == 2) {
        this.form.splice(this.delIndex, 1);
        this.deleteFormVisible=false
      }
      if (this.delItem.addressType == 1) {
        this.levelIDNum = this.delItem.levelID;
        this.deleteList();
      }
      // console.log('item',item);
      // 子组件向父组件传值（此处传递一个空值） - 父组件将执行getContent方法
      // this.$emit("func", item.levelID);
    },
    // 新增数据
    createList() {
      return this.form;
    },
    deleteList() {
      ruleDeleteApi({
        cpyNO: getcpyNo(),
        levelID: this.levelIDNum,
      }).then((res) => {
        if (res.message == "success") {
          this.$message.success("删除成功!");
          this.$parent.lookList();
          this.deleteFormVisible=false
        }
      });
    },
    //升级条件
    changeUpCondition(item) {
      if(item.upCondition==0){
        item.timeLength=""
        item.sumAmt=""
        item.oneMaxAmt1=""
        item.oneMaxAmt2=""
      }
    }, 
    //等级有效期
    changeLvlAvailMode(item){
      console.log(item)
      if(item.lvlAvailMode===2){    
        item.implClassName=""
      }else if(item.lvlAvailMode==3){
         item.lvlAvailMonth=""
      }else{
        item.lvlAvailMonth=""
        item.implClassName=""
      }
    },
    getaccountmnglvlSelectList(){
     accountmnglvlSelectList().then((res)=>{
      console.log(res,'res');
      this.lists=res.data
      this.lists.push({
        accountName:"无",
        accountLvlID:""
      })
     })
    }
  },
};
</script> 
<style lang="scss" scoped>
 /deep/.el-dialog__header{
   background-color: #b6b388;
 }
 /deep/.el-dialog__footer{
   background-color: #ccc;
   justify-content: center;
   text-align: center;
 }
</style> 

